// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// MIT License

import { BravuraFont } from './bravura_glyphs';
import { BravuraMetrics } from './bravura_metrics';

export const Bravura = {
  data: BravuraFont,
  metrics: BravuraMetrics,
};
